import React, { useState } from 'react';
import './TrialExpiredModal.css';

interface AcademicApprovedTrialModalProps {
  daysRemaining: number;
  onActivate: () => Promise<void>;
  onContinueTrial: () => void;
}

const AcademicApprovedTrialModal = ({
  daysRemaining,
  onActivate,
  onContinueTrial,
}: AcademicApprovedTrialModalProps) => {
  const [activating, setActivating] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleActivate = async () => {
    setActivating(true);
    setError(null);
    try {
      await onActivate();
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to activate academic access');
      setActivating(false);
    }
  };

  const daysLabel = daysRemaining === 1 ? '1 day' : `${Math.max(daysRemaining, 0)} days`;

  return (
    <div className="trial-modal-overlay">
      <div className="trial-modal-content" onClick={e => e.stopPropagation()}>
        <div className="trial-modal-icon" style={{ color: '#667eea' }}>
          <i className="bi bi-mortarboard"></i>
        </div>

        <h2 className="trial-modal-title">Academic Application Approved</h2>

        <p className="trial-modal-message">
          Your Free Academic Plan application has been approved. You still have{' '}
          <strong>{daysLabel}</strong> left in your trial with full access.
        </p>

        <p className="trial-modal-message">
          You can activate your academic account now or continue using your trial until it ends.
        </p>

        {error && (
          <p className="trial-modal-message" style={{ color: '#dc3545' }}>
            {error}
          </p>
        )}

        <div className="trial-modal-actions">
          <button
            className="btn-gradient-blue trial-modal-btn-primary"
            onClick={handleActivate}
            disabled={activating}
          >
            {activating ? 'Activating…' : 'Activate now'}
          </button>
          <button
            className="trial-modal-btn-secondary"
            onClick={onContinueTrial}
            disabled={activating}
          >
            Continue with trial
          </button>
        </div>
      </div>
    </div>
  );
};

export default AcademicApprovedTrialModal;
